import { SharedModule } from "src/app/pages/shared/modules/shared.module";
import { DatePickerModule } from "@syncfusion/ej2-angular-calendars";
import { BrowserModule } from "@angular/platform-browser";
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { NgxTranslateModule } from "./core/translate/translate.module";

import { InterceptorService } from "./core/helpers/interceptors/interceptor.service";
import { SignInComponent } from "./pages/landing-pages/authentication/sign-in/sign-in.component";
import { RecoverPasswordComponent } from "./pages/landing-pages/authentication/recover-password/recover-password.component";
import { SetNewPasswordComponent } from "./pages/landing-pages/authentication/set-new-password/set-new-password.component";
import { LandingNavComponent } from "./pages/landing-pages/landing-nav/landing-nav.component";
import { HomeComponent } from "./pages/landing-pages/home/home.component";
import { UserLayoutComponent } from "./pages/user/user-layout/user-layout.component";
import { FooterComponent } from "./pages/landing-pages/footer/footer.component";
import { DashboardComponent } from "./pages/user/user-layout/dashboard/dashboard.component";
import { ManageAppsComponent } from './pages/user/user-layout/manage-apps/manage-apps.component';
import { CleanupPipe } from "./pages/user/user-layout/manage-devices/pipes/cleanup.pipe";
import { VerifyInviteComponent } from './pages/landing-pages/authentication/verify-invite/verify-invite.component';




@NgModule({
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	declarations: [
		AppComponent,
		SignInComponent,
		RecoverPasswordComponent,
		SetNewPasswordComponent,
		LandingNavComponent,
		HomeComponent,
		UserLayoutComponent,
		FooterComponent,
		DashboardComponent,
		ManageAppsComponent,
		CleanupPipe,
		VerifyInviteComponent,
	],
	bootstrap: [AppComponent],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		AppRoutingModule,
		FormsModule,
		ReactiveFormsModule,
		DatePickerModule,
		SharedModule,
		NgxTranslateModule
	],
	providers: [
		{
			provide: HTTP_INTERCEPTORS,
			useClass: InterceptorService,
			multi: true,
		},
		{
			provide: 'nonce',
			useValue: 'randomNonceGoesHere'
		},
		provideHttpClient(withInterceptorsFromDi())
	]
})
export class AppModule { }
